import { identity } from "ramda";
import {
  DELETE_GAQ_RELEASE_NOTE,
  DELETE_GAQ_RELEASE_NOTE_SUCCESS,
  DELETE_GAQ_RELEASE_NOTE_FAILURE,
  RESET_DELETE_GAQ_RELEASE_NOTE,
} from "../../../../actions";
import RD from "../../../../utils/functional/remote-data";

const INITIAL_STATE = RD.notAsked();

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case RESET_DELETE_GAQ_RELEASE_NOTE:
      return RD.notAsked();

    case DELETE_GAQ_RELEASE_NOTE:
      return RD.loading();

    case DELETE_GAQ_RELEASE_NOTE_SUCCESS:
      return RD.success(payload);

    case DELETE_GAQ_RELEASE_NOTE_FAILURE:
      return RD.error(payload);

    default:
      return state;
  }
};

export const get = identity;

export default reducer;
